/* eslint-disable prefer-const */
/* eslint-disable import/prefer-default-export */
const helpers = {};
helpers.convertToAmPm = (time) => {
    let [hours, minutes, seconds] = time.split(':');
    hours = parseInt(hours, 10);
    const period = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12 || 12;

    return `${hours.toString().padStart(2, '0')}:${minutes}:${seconds} ${period}`;
};
export const { convertToAmPm } = helpers;
